import { okr_permission } from "./okr.permission";
import { runpod_permission } from "./runpod.permission";

export const  coaching_engagement_permission= {
    required_permission: ["view_coachingconversation", "add_coachingconversation", "change_coachingconversation", "delete_coachingconversation",
    "view_actionitem", "add_actionitem", "change_actionitem", "delete_actionitem","view_competency", "add_competency", "change_competency", "delete_competency" 
    ].concat(okr_permission.requried_permission),
    runpod_permission:runpod_permission?.required_permission
}